
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 198.43 198.43","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M169.57 33.31c7.06 5.92 11.95 13.2 14.69 21.86 2.73 8.66 3.13 17.37 1.19 26.13-1.93 8.77-6.09 16.34-12.46 22.72l-65.92 68.31c-2.28 2.28-4.9 3.42-7.86 3.42s-5.58-1.14-7.85-3.42l-65.92-67.97c-6.38-6.6-10.54-14.29-12.47-23.06-1.94-8.76-1.54-17.47 1.2-26.13 2.73-8.66 7.62-15.94 14.68-21.86 6.15-5.24 13.1-8.54 20.84-9.91s15.37-.8 22.88 1.71c7.52 2.5 14.12 6.72 19.81 12.63l6.83 6.83 6.83-6.83c5.69-5.92 12.3-10.13 19.81-12.63 7.51-2.51 15.14-3.08 22.88-1.71 7.75 1.37 14.7 4.68 20.84 9.91z","fill":"#fff","stroke":"#b5353f","stroke-width":"6","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    